// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkElement_link__tXkuR"};